import styled, { css } from "styled-components";

export const ToggleContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 103.5%;

  label {
    margin-bottom: 12px;
    font-style: normal;
    font-weight: normal;
    font-size: 0.9rem;
    color: var(--grey-100);
  }
`;

export const ToggleButton = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
`;

type Props = {
  isActive: boolean;
};

export const Button = styled.button<Props>`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 0.875rem;
  height: 3rem;
  background-color: var(--black-100) !important;
  border: 1px solid var(--grey-200);
  width: 50% !important;
  color: var(--white);
  flex-grow: 1;

  ${({ isActive }) =>
    isActive &&
    css`
      border-radius: 0px 4px 4px 0px;
      margin-right: auto;
      height: 3rem;
      color: var(--white);
      background-color: var(--black-100);
      border: 1px solid var(--primary);
    `};

  img {
    width: 1rem;
    height: 1rem;
  }
`;
